<script setup lang="ts">
import { ExclamationCircleIcon, UserCircleIcon } from '@heroicons/vue/solid'
import { i18n } from '../../../localization'
import Alert from '../../base/Alert.vue'
import { navigateTo } from '../../../utilities/account/useAccountNavigationLegal'

defineProps<{
    inline?: boolean
    descriptionText?: string
}>()

async function navigateToComplianceProfile() {
    await navigateTo('Compliance Profile')
}
</script>
<template>
    <Alert
        :inline="inline"
        :title-text="i18n.global.t('compliance_profile.complete_data')"
        :description-text="i18n.global.t('compliance_profile.complete_data_description')"
        :button-text="i18n.global.t('verification.complete_data_action_button')"
        show-button
        @click-button="navigateToComplianceProfile">
        <template #icon>
            <UserCircleIcon class="h-12 w-12 text-gray-300"></UserCircleIcon>
            <ExclamationCircleIcon
                class="absolute bottom-0 right-[-5px] h-6 w-6 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
        </template>
    </Alert>
</template>
